import * as React from 'react';
import { SummaryDashboardStore } from 'nomst/Stores/SummaryDashboard/summaryDashboard.store';
import { navigateToNoMst } from 'utils/MobxDataManager/singletons';
import { configurationsStore } from 'utils/MobxDataManager/singletons';
import { WorkflowStatus } from 'typings/enums';
import { listTypeFromWorkflowStatusMap } from 'nomst/Stores/Decision/Constants/workflowStatusMap';

const workflowStatusClassNameMap = new Map<string, string>([
    [WorkflowStatus.Open, 'nomst-team-progress-row--open'],
    [WorkflowStatus.InProgress, 'nomst-team-progress-row--in-progress'],
    [WorkflowStatus.PendingReview, 'nomst-team-progress-row--pending-review'],
    [WorkflowStatus.Approved, 'nomst-team-progress-row--approved']
]);

interface ITeamworkflowSummaryRowProps {
    teamWorkflowSummary: IStatusSummary;
    summaryDashboardStore: SummaryDashboardStore;
}

export default class TeamWorkflowSummaryRow extends React.Component<ITeamworkflowSummaryRowProps> {
    constructor(props: ITeamworkflowSummaryRowProps) {
        super(props);
        this.handleGotoView = this.handleGotoView.bind(this);
    }

    render(): React.ReactNode {
        const { teamWorkflowSummary } = this.props;
        const numberClasses = this.getNumberClass(teamWorkflowSummary.statusCount);
        const statusClass = workflowStatusClassNameMap.get(teamWorkflowSummary.status) || '';
        return (
            <div className={`nomst-team-progress-row ${numberClasses} ${statusClass}`}>
                <button
                    className={'nomst-team-progress-row__count pxl-link'}
                    onClick={this.handleGotoView}
                >
                    {teamWorkflowSummary.statusCount}
                </button>
                <p className="nomst-team-progress-row__status">
                    <span className="nomst-team-progress-row__status-name">
                        {teamWorkflowSummary.status}
                    </span>
                    <span className="nomst-team-progress-row__status-description">
                        {this.renderStatusCategoryText()}
                    </span>
                </p>
            </div>
        );
    }

    private renderStatusCategoryText(): string {
        const { teamWorkflowSummary } = this.props;
        const status = teamWorkflowSummary.status;
        switch (status) {
            case WorkflowStatus.Open:
                return 'Teams have not started';
            case WorkflowStatus.InProgress:
                return 'Teams in process of making decisions';
            case WorkflowStatus.PendingReview:
                return 'Teams sent to the next reviewer';
            case WorkflowStatus.Approved:
                return 'Teams completed and locked';
            default:
                return '';
        }
    }

    // TODO PSP-23064: Update classes for zero or non-zero statues on new dashboard as needed
    private getNumberClass(value: number, clickable: boolean = true): string {
        let cssClasses = 'num' + (value === 0 ? ' num-zero' : '');
        if (!clickable) {
            cssClasses += ' default-cursor';
        }

        return cssClasses;
    }

    private handleGotoView(): Promise<void> {
        const listType = listTypeFromWorkflowStatusMap.get(this.props.teamWorkflowSummary.status as WorkflowStatus) ||
            this.props.teamWorkflowSummary.status;
        return navigateToNoMst.navigateToManagerView(configurationsStore.currentCycleId, listType);
    }
}